import red from "@mui/material/colors/red";
import { createTheme, Theme } from "@mui/material/styles";
import { Environments } from "types/common-types";

class ColorPalette {
  constructor(primary: string, secondary: string) {
    this.primary = primary;
    this.secondary = secondary;
    this.tertiary = "#E8E8E8";
    this.contrastText = "#333333";
    this.paper = "#F1F7FF";
    this.disabled = "#D3D3D3";
  }

  primary: string;
  secondary: string;
  tertiary: string;
  paper: string;
  disabled: string;
  contrastText: string;
}

const getPalette = (env: string): ColorPalette => {
  switch (env) {
    case Environments.Local:
    case Environments.Dev: {
      return new ColorPalette("#336633", "#455449");
    }
    case Environments.Qa: {
      return new ColorPalette("#993333", "#806C58");
    }
    default:
      /*PROD*/
      return new ColorPalette("#1D3E4E", "#DF7B32");
  }
};

const getTheme = (env: string): Theme => {
  const palette = getPalette(env);

  return createTheme({
    palette: {
      primary: { main: palette.primary, light: palette.paper },
      secondary: {
        main: palette.secondary,
        light: palette.tertiary,
        dark: palette.disabled,
        contrastText: palette.contrastText,
      },
      error: { main: red.A400 },
      tertiary: { main: palette.tertiary },
      gray: { main: "#F1F5F9" },
    },
    components: {
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginLeft: 0,
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: (themeParam) => ({
          body: {
            backgroundColor: "white",
          },

          // Various global styles for TinyMCE
          ".tox-tinymce-inline": {
            "z-index": "9999999 !important",
          },
          ".mce-edit-focus": {
            outline: "none",
          },
          ".mce-content-body": {
            "& > *:first-child": {
              marginTop: 4,
            },
            "& > *:last-child": {
              marginBottom: 4,
            },
          },
        }),
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: palette.secondary,
            color: "white",
            fontWeight: "bold",
            ".MuiTableCell-root": {
              backgroundColor: palette.secondary,
              color: "white",
              fontWeight: "bold",
            },
            ".MuiTableSortLabel-root": {
              color: "white !important",
              svg: { color: "white !important" },
            },
            ".MuiDivider-root": {
              backgroundColor: "white",
              opacity: 0.3,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: ".6rem",
          },
        },
      },
    },
  });
};

export default getTheme;
